export const API_PATH_ApiZipCreatorCancelProcess = '/services/zip-creator/apiZipCreatorCancelProcess';
